import classNames from "classnames";

export type CardCaptionContent = {
    color: string;
    text: string;
    week: number;
};

type CaptionCardProps = {
    captions: Array<CardCaptionContent>;
    className?: string;
};

const getPureColor = (color: string) => color.replace("bg-[", "").replace("]", "");

export const CaptionCards = ({ captions, className }: CaptionCardProps) => {
    return (
        <div className={classNames("absolute -top-5 right-4 flex gap-2", className)}>
            {captions.map((caption, index) => (
                <a
                    className="text-black px-3 py-1 rounded-[30px] text-xl font-normal bg-white border-[3px]"
                    href={caption.week ? `#week-${caption.week}` : undefined}
                    key={`caption-${index}`}
                    style={{ borderColor: getPureColor(caption.color) }}
                >
                    {caption.text}
                </a>
            ))}
        </div>
    );
};
